import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { Feature } from 'types';
import { AppRoutes } from 'config';
import { useHeader } from 'context';
import { useAppSelector } from 'store';
import { Flex, Tabs, TabsItem } from 'components';
import { selectAuthUserFeatures } from 'store/slices/auth';

const { EventOrders, ExchangeOrders } = AppRoutes.Shipments.Children;

const Shipments = () => {
  const authUserFeatures = useAppSelector(selectAuthUserFeatures);

  useHeader({
    pageName: 'Shipments',
  });

  const tabs = useMemo(() => {
    const result: TabsItem[] = [];

    if (authUserFeatures?.includes(Feature.EVENT_ORDERS)) {
      result.push({
        to: EventOrders.Home,
        label: 'Event orders',
      });
    }

    result.push({
      to: ExchangeOrders.Home,
      label: 'Exchange orders',
    });

    return result;
  }, [authUserFeatures]);

  return (
    <Flex column fullWidth>
      {tabs.length && <Tabs items={tabs} style={{ padding: '16px' }} />}

      <Outlet />
    </Flex>
  );
};

export default Shipments;
